import Footer from "../Layout/Footer";
import React, { useEffect } from "react";
import Header from "../Layout/Header";
import { gpColors } from "../../constants/colors";
import {
  Button,
  makeStyles,
  Link,
  Box,
  Container,
  TextField,
  Typography,
  Snackbar,
  IconButton,
  Divider,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";
import {Helmet} from 'react-helmet'
import useMediaQuery from '@mui/material/useMediaQuery';
import usePhoneSize from "../responsive/usePhoneSize";
import useTabletSize from "../responsive/useTabletSize";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  aboutHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  aboutContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
  },
  textFieldStyle: {
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      width: "123%",
    },
    "& label.Mui-focused": {
      color: "Blue",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "Blue",
      },
      "&:hover fieldset": {
        borderColor: "Blue",
      },
    },
  },
  bulletHeadings: {
    fontSize:'15px',
    fontWeight: 600,
    marginRight: "5px",
  },
  AboutDev: {
    backgroundColor: "white",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "1%",
    boxShadow: '5px 10px 15px grey',
    paddingTop:'3%',
    paddingBottom:'3%',
  },
  AboutPara: {
    width: "32%",
    paddingLeft: "3%",
    paddingRight: "3%",
    alignItems: "center",
    wordBreak:'break-word',
    border:'5px black',
  },

  textstyle: {
    fontSize: "15px",
    fontWeight: 500,
  },
  AboutPara2: {
    wordBreak:'break-word',
    width: "48%",
    paddingLeft: "3%",
    paddingRight: "3%",
    justifyContent:'center',
    alignItems: "center",
  },
  AboutDev2: {
    backgroundColor: "white",
    width: "70%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "1%",
    boxShadow: '5px 10px 15px grey',
    paddingTop:'3%',
    paddingBottom:'3%',
  },
}));
const AboutUs = () => {
  const classes = useStyles();


  const phonesize=usePhoneSize()


  const tabletsize = useTabletSize()

  const [isHovering, setIsHovering] = useState(false);
  const [isHovering1, setIsHovering1] = useState(false);
  const [isHovering2, setIsHovering2] = useState(false);
  const [isHovering3, setIsHovering3] = useState(false);
  const [isHovering4, setIsHovering4] = useState(false);



  useEffect(() => {
    // console.log('rendered')
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const [contactDetails, setContactDetails] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  const [error, setError] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  function handleChange(e) {
    let value = e.target.value;
    let name = e.target.name;

    setContactDetails({ ...contactDetails, [name]: value });
    setError({ ...error, [name]: "" });
  }

  function submitContactDetails(e) {
    e.preventDefault();
    if (
      contactDetails.name.length === 0 &&
      contactDetails.phone_number.length === 0 &&
      contactDetails.emailId.length === 0 &&
      contactDetails.message.length === 0
    ) {
      setError({
        ...error,
        name: "Please enter name.",
        phone_number: "Please enter phone number.",
        emailId: "Please enter email ID",
        message: "Please enter message.",
      });
    } else if (contactDetails.name.length === 0) {
      setError({
        ...error,
        name: "Please enter name.",
      });
      if (contactDetails.phone_number.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          phone_number: "Please enter phone number",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            message: "Please enter messsage.",
          });
        } else if (contactDetails.emailId.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            emailId: "Please enter email ID.",
          });
        }
      } else if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.phone_number.length === 0) {
      setError({
        ...error,
        phone_number: "Please enter phone number",
      });
      if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            phone_number: "Please enter phone number",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.emailId.length === 0) {
      setError({
        ...error,
        emailId: "Please enter email ID.",
      });
      if (contactDetails.message.length === 0) {
        setError({
          ...error,
          emailId: "Please enter email ID.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.message.length === 0) {
      setError({
        ...error,
        message: "Please enter message.",
      });
    } else if (contactDetails.phone_number.match(/^[0-9]+$/) === null) {
      // check phone number have only numbers or not
      setError({
        ...error,
        phone_number: "Phone number must be have only numbers.",
      });
    } else if (
      contactDetails.emailId.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      ) === null
    ) {
      // check email id is valid or not
      setError({
        ...error,
        emailId: "Please enter valid Email ID.",
      });
    } else {
      //when all validations are done then API call for send email
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/send-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // // "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify(contactDetails),
      })
        .then((response) => response.json())
        .then((json) => {
          console.log("Status", json);
          if (json.hasOwnProperty("status")) {
            if (json.status === "Mail Sent Successfully") {
              // after successfully submitted form show success message
              setSuccessSubmit(true);
            }
          }
        });
      setContactDetails({
        ...contactDetails,
        name: "",
        phone_number: "",
        emailId: "",
        message: "",
      });
    }
  }
  // const phonesize = usePhoneSize()
  const [successSubmit, setSuccessSubmit] = useState(false);
  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSubmit(false);
  };
   

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Experience superior quality automotive filters that deliver unmatched performance and reliability. Our stringent manufacturing processes and rigorous quality control ensure the highest standards in filtration. Trust our ISO-certified quality management system for dependable filters that protect your vehicles. Explore our commitment to excellence and customer satisfaction on our quality page."
        />
      </Helmet>
      <Header />
      <Container>
        <div className={classes.container}>
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={classes.aboutHeader}>About Us</div>
            </div>
            <div className={classes.aboutContent}>
              <p>Welcome to GuardPlus Autocomp!</p>
              <p>
                GuardPlus is a young and vibrant company located in India,
                manufacturing light, medium, and heavy-duty automotive filters.
                Our filters are manufactured to the highest quality in the
                marketplace and meet the original equipment fit, form, and
                function. We aim to be the industry leader in providing the best
                quality products and services. With our commitment to excellence
                and advanced manufacturing processes, we deliver reliable and
                efficient filtration solutions that keep your vehicles running
                smoothly and protect them from harmful contaminants.
              </p>
              <p>Why Choose GuardPlus Automotive Filters?</p>

             <div style={{display:phonesize?'block':'flex',flexWrap:'wrap',justifyContent:'center'}}>
              <div onMouseOver={()=>{setIsHovering(true)}} onMouseOut={()=>{setIsHovering(false)}} className={classes.AboutPara} style={{width:phonesize?'100%':'32%', boxShadow: '1px 2px 9px grey', marginRight:'1%',height:tabletsize?phonesize?'auto':isHovering?'370px':'360px':isHovering?'350px':'290px',marginBottom:'1%'}}>
              <p>
                <span className={classes.bulletHeadings} style={{fontSize:isHovering?tabletsize?'14px':'17px':tabletsize?'13px':'16px'}}>
                  Superior Quality
                </span>
                </p>
                <div className={classes.textstyle} style={{fontSize:isHovering?tabletsize?'13px':'15px':tabletsize?'12px':'14px'}}>
                <p>
                We are committed to providing the highest quality filters that
                meet or exceed industry standards. Our filters undergo rigorous
                testing and quality control processes to ensure they deliver
                exceptional performance and durability.
              </p>
              </div>
              </div>


              <div onMouseOver={()=>{setIsHovering1(true)}} onMouseOut={()=>{setIsHovering1(false)}} className={classes.AboutPara} style={{width:phonesize?'100%':'32%',boxShadow: '1px 2px 9px grey',height:tabletsize?phonesize?'auto':isHovering1?'370px':'360px':isHovering1?'350px':'290px',marginBottom:'1%' }}>
              <p>
                <span className={classes.bulletHeadings} style={{fontSize:isHovering1?tabletsize?'14px':'17px':tabletsize?'13px':'16px'}}>
                Advanced Filtration Technology
                </span>
                </p>
                <div className={classes.textstyle} style={{fontSize:isHovering1?tabletsize?'13px':'15px':tabletsize?'12px':'14px'}}>
                <p>
                Our filters are designed with advanced filtration media and
                innovative technology that effectively captures and retains
                contaminants, keeping your engine clean and protected.
              </p>
              </div>
              </div>
              
              

              <div onMouseOver={()=>{setIsHovering2(true)}} onMouseOut={()=>setIsHovering2(false)} className={classes.AboutPara} style={{width:phonesize?'100%':'32%',boxShadow: '1px 2px 9px grey', marginLeft:'1%',height:tabletsize?phonesize?'auto':isHovering2?'370px':'360px':isHovering2?'350px':'290px',marginBottom:'1%'}}>
              <p>
                <span className={classes.bulletHeadings} style={{fontSize:isHovering2?tabletsize?'14px':'17px':tabletsize?'13px':'16px'}}>
                Customization Options
                </span>
                </p>
                <div className={classes.textstyle} style={{fontSize:isHovering2?tabletsize?'13px':'15px':tabletsize?'12px':'14px'}}>
                <p>
                We understand that different vehicles and applications have
                unique requirements. That's why we offer customization options
                to tailor our filters to your specific needs. From specialized
                sizes to custom branding, we can work with you to create a
                filter that meets your exact specifications.
              </p>
              </div>
              </div>
              
              {/* <div style={{display:phonesize?'block':'flex',marginTop:phonesize?'auto':'1%',justifyContent:'center',}}> */}
              <div onMouseOver={()=>{setIsHovering3(true)}} onMouseOut={()=>setIsHovering3(false)} className={classes.AboutPara} style={{width:phonesize?'100%':'32%',boxShadow: '1px 2px 9px grey', marginRight:'0.5%',height:tabletsize?phonesize?'auto':isHovering3?'370px':'360px':isHovering3?'350px':'290px',marginBottom:'1%'}}>
              <p>
                <span className={classes.bulletHeadings} style={{fontSize:isHovering3?tabletsize?'14px':'17px':tabletsize?'13px':'16px'}}>
                Competitive Pricing
                </span>
                </p>
                <div className={classes.textstyle} style={{fontSize:isHovering3?tabletsize?'13px':'15px':tabletsize?'12px':'14px'}}>
                <p>
                We believe that top-quality products should be accessible to
                all. Our competitive pricing ensures that you get the best value
                for your investment without compromising on performance or
                quality.
              </p>
              </div>
              </div>

              <div onMouseOver={()=>{setIsHovering4(true)}} onMouseOut={()=>setIsHovering4(false)} className={classes.AboutPara} style={{width:phonesize?'100%':'32%',boxShadow: '1px 2px 9px grey', marginLeft:'0.5%',height:tabletsize?phonesize?'auto':isHovering4?'370px':'360px':isHovering4?'350px':'290px',marginBottom:'1%'}}>
              <p>
                <span className={classes.bulletHeadings} style={{fontSize:isHovering4?tabletsize?'14px':'17px':tabletsize?'13px':'16px'}}>
                Excellent Customer Support
                </span>
                </p>
                <div className={classes.textstyle} style={{fontSize:isHovering4?tabletsize?'13px':'15px':tabletsize?'12px':'14px'}}>
                <p>
                Our dedicated customer support team is always ready to assist
                you with any inquiries or concerns. We strive to provide prompt
                and helpful responses, ensuring your satisfaction throughout
                your experience with GuardPlus.
              </p>
              </div>
              </div>
              {/* </div> */}

              </div>
              

               {/* <div style={{display:'flex',justifyContent:'center', flexDirection:'column',alignItems:'center',marginBottom:'42px'}}> */}
              {/* <div className={classes.AboutDev}> */}
                {/* <div className={classes.AboutPara} style={{paddingRight:'3%'}}> */}
              {/* <p> */}
                {/* <span className={classes.bulletHeadings}> */}
                  {/* Superior Quality */}
                {/* </span> */}
                {/* </p> */}
                {/* <div className={classes.textstyle}> */}
                {/* <p> */}
                {/* We are committed to providing the highest quality filters that */}
                {/* meet or exceed industry standards. Our filters undergo rigorous */}
                {/* testing and quality control processes to ensure they deliver */}
                {/* exceptional performance and durability. */}
              {/* </p> */}
              {/* </div> */}
              {/* </div> */}
              {/* <div> */}
                  {/* {" "} */}
                  {/* <Divider orientation="vertical" /> */}
                {/* </div> */}
              {/* <div className={classes.AboutPara}style={{paddingLeft:'3%',paddingRight:'3%'}}> */}
              {/* <p> */}
                {/* <span className={classes.bulletHeadings}> */}
                  {/* Advanced Filtration Technology */}
                {/* </span> */}
                {/* </p> */}
                {/* <div className={classes.textstyle}> */}
                {/* <p> */}
                {/* Our filters are designed with advanced filtration media and */}
                {/* innovative technology that effectively captures and retains */}
                {/* contaminants, keeping your engine clean and protected. */}
              {/* </p> */}
              {/* </div> */}
              {/* </div> */}
              {/* <div> */}
                  {/* {" "} */}
                  {/* <Divider orientation="vertical" /> */}
                {/* </div> */}
              {/* <div className={classes.AboutPara}style={{paddingLeft:'3%'}}> */}
              {/* <p> */}
                {/* <span className={classes.bulletHeadings}> */}
                  {/* Customization Options */}
                {/* </span> */}
               {/* </p> */}
               {/* <div className={classes.textstyle}> */}
               {/* <p> */}
                {/* We understand that different vehicles and applications have */}
                {/* unique requirements. That's why we offer customization options */}
                {/* to tailor our filters to your specific needs. From specialized */}
                {/* sizes to custom branding, we can work with you to create a */}
                {/* filter that meets your exact specifications. */}
              {/* </p> */}
              {/* </div> */}
              {/* </div> */}
              {/* </div> */}
              {/* <div className={classes.AboutDev2}> */}
                {/* <div className={classes.AboutPara2} style={{paddingRight:'3%'}}> */}
              {/* <p> */}
                {/* <span className={classes.bulletHeadings}> */}
                  {/* Competitive Pricing */}
                {/* </span> */}
                {/* </p> */}
                {/* <div className={classes.textstyle}> */}
                {/* <p> */}
                {/* We believe that top-quality products should be accessible to */}
                {/* all. Our competitive pricing ensures that you get the best value */}
                {/* for your investment without compromising on performance or */}
                {/* quality. */}
              {/* </p> */}
              {/* </div> */}
              {/* </div> */}
              {/* <div> */}
                  {/* {" "} */}
                  {/* <Divider orientation="vertical" /> */}
                {/* </div> */}
              {/* <div className={classes.AboutPara2} style={{paddingLeft:'3%'}}> */}
              {/* <p> */}
                {/* <span className={classes.bulletHeadings}> */}
                  {/* Excellent Customer Support */}
                {/* </span> */}
                {/* </p> */}
                {/* <div className={classes.textstyle}> */}
                {/* <p> */}
                {/* Our dedicated customer support team is always ready to assist */}
                {/* you with any inquiries or concerns. We strive to provide prompt */}
                {/* and helpful responses, ensuring your satisfaction throughout */}
                {/* your experience with GuardPlus. */}
                {/* </p> */}
                {/* </div> */}
             {/* </div> */}
              {/* </div> */}
              {/* </div> */}
              <p>
                Contact us today to learn more about our automotive filters and
                how we can meet your filtration needs. Trust GuardPlus for
                reliable performance, exceptional quality, and superior engine
                protection
              </p>
            </div>
          </div>
        </div>
        <div style={{ margin: "12px" }}>
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            <Box
              padding={2}
              sx={{ width: { md: "100%", sm: "50%" }, fontSize: "16px" }}
            >
              <Typography variant="h6" component="h6">
                CONTACT US
              </Typography>
              <Link color="inherit" href="mailto:sales@gpautocomp.com">
                sales@gpautocomp.com
              </Link>
              <Box style={{ marginBottom: "20px" }}>+91 9979842040</Box>
              <Box>
                Address: Plot No 1108, Phase – II, GIDC, Chhatral, Tal Kalol,
                Dist Gandhinagar – 382729.
              </Box>
            </Box>
            <Box padding={2} sx={{ width: { md: "100%", sm: "50%" } }}>
              <Typography variant="h6" component="h6">
                SEND US INQUIRY
              </Typography>
              <form>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Name*"
                    variant="outlined"
                    size="small"
                    name="name"
                    value={contactDetails.name}
                    onChange={(e) => handleChange(e)}
                    error={error.name ? true : false}
                    helperText={error.name}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Phone Number*"
                    variant="outlined"
                    size="small"
                    name="phone_number"
                    value={contactDetails.phone_number}
                    onChange={(e) => handleChange(e)}
                    error={error.phone_number ? true : false}
                    helperText={error.phone_number}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Email*"
                    variant="outlined"
                    size="small"
                    name="emailId"
                    type="email"
                    value={contactDetails.emailId}
                    onChange={(e) => handleChange(e)}
                    error={error.emailId ? true : false}
                    helperText={error.emailId}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Message*"
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                    name="message"
                    value={contactDetails.message}
                    onChange={(e) => handleChange(e)}
                    error={error.message ? true : false}
                    helperText={error.message}
                  />
                </Box>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  endIcon={<SendIcon />}
                  onClick={(e) => submitContactDetails(e)}
                >
                  Send
                </Button>
              </form>
            </Box>
          </Box>
        </div>
      </Container>

      {/* after successfully submitted form show success message */}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ContentProps={{
          style: { background: "green" },
        }}
        open={successSubmit}
        autoHideDuration={5000}
        onClose={handleCloseSuccess}
        message="Your form has been submitted successfully!"
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseSuccess}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
      <Footer />
    </>
  );
};

export default AboutUs;
